export default "__VITE_ASSET__oOMoMtx7__"